import { createFileRoute, useParams } from '@tanstack/react-router'
import { useNavigate } from '@tanstack/react-router';
import { useQueryClient } from '@tanstack/react-query';
import { keyCompetitionJumps, keyCompetitionAll } from '@/api/query-keys';
import Uploading from '@/components/Uploading';
import { useSubscription } from '@/hooks/useSubscription.hook';
import { useUpload, type UploadState } from '@/hooks/useUpload.hook';
import { type SubscriptionTopic, type EventPayload, EventAction, Entity } from '@/api/model/subscription-topic';

const route = '/uploading/$assetId';

export const Route = createFileRoute(route)({
  component: UploadingPage,
})

function UploadingPage() {
  const navigate = useNavigate();
  const { entity, entityId } = useUpload((state: UploadState) => state);
  const queryClient = useQueryClient();
  const topic: SubscriptionTopic = {
      entity: entity!,
      identifier: entityId!
  };
  useSubscription(topic, (payload: EventPayload) => {
      console.log(`EVENT in Uploading: ${JSON.stringify(payload)}`)
      if (payload.activity === EventAction.CREATED) {
          if (entity === Entity.COMPETITION) {
            queryClient.invalidateQueries({ queryKey: keyCompetitionAll() }).then(() => {
              navigate({ to: `/draftcompetition/${entityId}`, viewTransition: true });
            })
          } else {
            queryClient.invalidateQueries({ queryKey: keyCompetitionJumps() }).then(() => {
              navigate({ to: `/draftsubmission/${entityId}`, viewTransition: true });
            })
          }
      }
  });
  const { assetId } = useParams({ from: route });
  return (<Uploading assetId={assetId} />);
}
